<template>
    <div id="contact-us-page">

        <section-banner-small :picture-url="bannerInfo.pictureUrl" :title="bannerInfo.title"></section-banner-small>

        <div class="fixed-spy">
            <div class="container">
                <div class="row">

                    <!-- Side menu -->
                    <div class="d-none d-lg-block col-lg-3 lateral-menu-cont">
                        <div class="fixed-element">
                            <ul v-scroll-spy-active v-scroll-spy-link class="section-nav lateral-menu-jump">
                                <li v-if="user">
                                    <a class="font-md link-style d-block">
                                        <i class="material-icons">send</i> <span class="d-none d-lg-inline">Send us a message</span>
                                    </a>
                                </li>
                                <li>
                                    <a class="font-md link-style d-block">
                                        <i class="material-icons">info</i> <span class="d-none d-lg-inline">Additional info</span>
                                    </a>
                                </li>
                                <li>
                                    <a class="font-md link-style d-block">
                                        <i class="material-icons">get_app</i> <span class="d-none d-lg-inline">UJV App</span>
                                    </a>
                                </li>
                                <a :href="companyInfo.tollFreePhone.getURI()" class="font-md link-style text-center margin-top-10 d-none d-lg-block">Call us: <span class="d-inline-block">{{ companyInfo.tollFreePhone.formatInternational() }}</span></a>
                            </ul>
                        </div>
                    </div>

                    <!-- Main content -->
                    <div class="col-lg-9 lateral-main-cont">
                        <div v-scroll-spy="{offset: 100}">

                            <!-- Contact Form Section -->
                            <section v-if="user" class="section-style px-xs-0">
                                <div data-aos="fade-left"
                                     data-aos-offset="100"
                                     data-aos-once="true"
                                     data-aos-duration="500">
                                    <div class="row" >
                                        <div class="col-12">
                                            <div class="box-form bg-white box-shadow rounded">
                                                <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Send us a message</h2>
                                                <form @submit.prevent="sendMessage">
                                                    <div class="row">
                                                        <div class="col-12 form-group">
                                                            <div v-if="errors.length" class="alert alert-danger">
                                                                <strong>Please correct the following error(s):</strong>
                                                                <ul>
                                                                    <li v-for="error in errors">{{ error }}</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12 col-md-6 form-group">
                                                            <label class="font-sm">First name</label>
                                                            <i class="material-icons">person_outline</i>
                                                            <input disabled v-model="user.first_name" name="first-name" type="text" class="form-control input-style" aria-describedby="First name">
                                                        </div>
                                                        <div class="col-12 col-md-6 form-group">
                                                            <label class="font-sm">Last name</label>
                                                            <i class="material-icons">person_outline</i>
                                                            <input disabled v-model="user.last_name" name="last-name" type="text" class="form-control input-style" aria-describedby="Last name">
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12 col-md-6 form-group">
                                                            <label class="font-sm">Email</label>
                                                            <i class="material-icons">mail_outline</i>
                                                            <input disabled v-model="defaultEmail.email" name="email" type="email" class="form-control input-style" aria-describedby="Email">
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-7 col-md-6 form-group">
                                                            <label class="font-sm">Phone</label>
                                                            <i class="material-icons">phone</i>
                                                            <input disabled v-model="defaultPhone.display_phone" name="phone" type="tel" class="form-control input-style" aria-describedby="Phone">
                                                        </div>
                                                        <div class="col-5 col-md-3 form-group">
                                                            <label class="font-sm">Ext</label>
                                                            <i class="material-icons">phone</i>
                                                            <input disabled v-model="defaultPhone.extension" name="phone-ext" type="tel" class="form-control input-style" aria-describedby="Ext">
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-12 form-group">
                                                            <label class="font-sm">Message</label>
                                                            <textarea v-model="message" name="message" class="form-control input-style" rows="4" aria-describedby="Message"></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="row margin-top-20 margin-bottom-20 justify-content-center">
                                                        <div class="col-auto">
                                                            <input type="submit" :disabled="loading" value="Send message" class="btn btn-primary btn-lg text-uppercase">
                                                        </div>
                                                        <div class="col-auto" style="margin-top: -30px; margin-left: -50px">
                                                            <loader v-if="loading" :radius="10" :stroke="2"></loader>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <!-- Additional Info Section -->
                            <section class="section-style bg-white section-style-white-lateral px-xs-0">
                                <div class="container"
                                     data-aos="fade-left"
                                     data-aos-offset="100"
                                     data-aos-once="true"
                                     data-aos-duration="500">
                                    <div class="row justify-content-end">
                                        <div class="col-lg-9 lateral-main-cont">
                                            <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md text-center">Additional information</h2>
                                            <section-phone-list></section-phone-list>
                                        </div>
                                    </div>
                                </div>

                            </section>

                            <!-- UJV App Section -->
                            <section class="section-style px-xs-0">
                                <div data-aos="fade-left"
                                     data-aos-offset="100"
                                     data-aos-once="true"
                                     data-aos-duration="500">
                                    <div class="row">
                                        <div class="col-12">
                                            <section-app-small></section-app-small>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import SectionBannerSmall from "../components/sections/BannerSmall"
    import SectionAppSmall from "../components/sections/AppSmall"
    import SectionPhoneList from "../components/sections/PhoneList"
    import Loader from "../components/misc/Loader"
    import multiAnalytics from "../../shared-js/multi-analytics";

    export default {
        components: { Loader, SectionBannerSmall, SectionAppSmall, SectionPhoneList},

        computed: {
            defaultEmail() {
                return _.first(this.user.memberEmails, {default: 1}) || {};
            },
            defaultPhone() {
                return _.first(this.user.memberPhones, {default: 1}) || {};
            },
            user() {
                return this.$store.getters["Auth/user"];
            }
        },

        data: function () {
            return {
                bannerInfo: {
                    title: "Contact us",
                    pictureUrl: "/assets/bg/contact-us-bg.jpeg"
                },
                companyInfo: this.$store.getters["Company/companyInfo"],
                errors: [],
                loading: false,
                message: "",
            };
        },

        methods: {
            sendMessage() {
                const vm = this;

                if(vm.loading) return;

                vm.validateForm();

                if(vm.errors.length)
                    return;

                vm.loading = true;

                this.$httpClient.request("post", "/api/actions/send-contact-us-message", {message: vm.message}, true)
                    .then(() => {
                        vm.message = "";

                        multiAnalytics.lead();
                    })
                    .finally(() => {
                        vm.loading = false;
                    })
            },
            validateForm() {
                this.errors = [];

                if (!this.message) {
                    this.errors.push("Message required.")
                }
            }
        },
    }
</script>
